// extracted by mini-css-extract-plugin
export var colorSquare = "_o6-0";
export var danger = "_o6-5";
export var lightPink = "_o6-8";
export var neutralBlue = "_o6-7";
export var neutralYellow = "_o6-6";
export var normal = "_o6-1";
export var primary = "_o6-2";
export var primaryLight = "_o6-3";
export var solidBlack = "_o6-g";
export var solidGreen = "_o6-b";
export var solidLightBlue = "_o6-d";
export var solidNavy = "_o6-c";
export var solidOrange = "_o6-f";
export var solidPink = "_o6-e";
export var solidRed = "_o6-9";
export var solidYellow = "_o6-a";
export var success = "_o6-4";